import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  decreaseCurrentQTY,
  increaseCurrentQTY,
  productDeleted
} from "../../../Redux/AddProducts/Actions";
import {
  addToCart,
  cartQtyDecrease,
  deleteCart
} from "../../../Redux/Cart/Actions";

const CartProduct = ({ cart }) => {
  const dispatch = useDispatch();

  const products = useSelector((state) => state.products);
  const product = products.find((product) => product.id === cart.id);
  const { id, productName, img, category, price, currentQty } = product;

  const handleQtyIncrement = (id) => {
    dispatch(addToCart(id));
    dispatch(decreaseCurrentQTY(id));
  };

  const handleQtyDecrement = (id) => {
    dispatch(cartQtyDecrease(id));
    dispatch(increaseCurrentQTY(id));
  };

  const handleDelete = (id) => {
    dispatch(deleteCart(id));
    dispatch(productDeleted(id));
  };

  return (
    <>
      <div className="cartCard">
        <div className="flex items-center col-span-6 space-x-6">
          {/* <!-- cart image --> */}
          <img className="lws-cartImage" src={img} alt="product" />
          {/* <!-- cart item info --> */}
          <div className="space-y-2">
            <h4 className="lws-cartName">{productName}</h4>
            <p className="lws-cartCategory">{category}</p>
            <p>
              BDT <span className="lws-cartPrice">{price}</span>
            </p>
          </div>
        </div>
        <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
          {/* <!-- amount buttons --> */}
          <div className="flex items-center space-x-4">
            <button
              disabled={currentQty <= 0 ? true : false}
              onClick={() => handleQtyIncrement(id)}
              className="lws-incrementQuantity"
            >
              <i className="text-lg fa-solid fa-plus"></i>
            </button>
            <span className="lws-cartQuantity">{cart.quantity}</span>
            <button
            // disabled={cart.quantity <= 1 ? true : false}
              // onClick={() => handleQtyDecrement(id)}
              onClick={cart.quantity > 1  ? () => handleQtyDecrement(id) : () => handleDelete(id)}
              className="lws-decrementQuantity"
            >
              <i className="text-lg fa-solid fa-minus"></i>
            </button>
          </div>
          {/* <!-- price --> */}
          <p className="text-lg font-bold">
            BDT{" "}
            <span className="lws-calculatedPrice">{cart.quantity * price}</span>
          </p>
        </div>
        {/* <!-- delete button --> */}
        <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
          <button
            onClick={() => handleDelete(id)}
            className="lws-removeFromCart"
          >
            <i className="text-lg text-red-400 fa-solid fa-trash"></i>
          </button>
        </div>
      </div>
    </>
  );
};

export default CartProduct;
